import React, { useState } from "react";
import { Tabs } from "antd";
import { useUserContext } from "../hooks/UserSettingProvider";
import SkimChemicalStockList from "../components/storage-skim/SkimChemicalStockList";
import SkimChemicalList from "../components/storage-skim/SkimChemicalList";
import SellChemicalList from "../components/setting-conponents/Seller/SellChemicalList";

export default function SkimChemicalView() {
  const tableRef = React.useRef(null);

  const items = [
    {
      key: "skimChemicalStockList",
      label: "สต๊อกสารเคมีสกิม",
      children: <SkimChemicalStockList />,
      permission : true,
    },
    {
      key: "skimChemicalList",
      label: "ชื่อสารเคมีสกิม",
      children: <SkimChemicalList />,
      permission : true,
    },
    {
      key: "chemical",
      label: "ผู้ขายสารเคมี",
      children: <SellChemicalList isDone={false} ref={tableRef} />,
      permission : true
    },
  ];

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="latexsaleslist"
        items={items.filter((item) => item.permission == true)}
        style={{ marginTop: 15 }}
      />      
    </div>
  );
}
